import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, null, -1)
const _hoisted_2 = { class: "bg-background dark:bg-backgroundDark h-full" }
const _hoisted_3 = ["dir"]
const _hoisted_4 = { class: "flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metainfo = _resolveComponent("metainfo")!
  const _component_ps_nav_tab_bar = _resolveComponent("ps-nav-tab-bar")!
  const _component_ps_nav_bar = _resolveComponent("ps-nav-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_footer_view = _resolveComponent("footer-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_metainfo, null, {
      title: _withCtx(({ content }) => [
        _createTextVNode(_toDisplayString(content ? `${content}` : ``), 1)
      ]),
      _: 1
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "app",
        dir: _ctx.psValueHolder.languageCode == "ar" ? "rtl" : "ltr" ,
        class: "w-full h-full flex flex-col min-h-screen"
      }, [
        _createVNode(_component_ps_nav_tab_bar, { topOfPage: _ctx.atTopOfPage }, null, 8, ["topOfPage"]),
        _createVNode(_component_ps_nav_bar, { topOfPage: _ctx.atTopOfPage }, null, 8, ["topOfPage"]),
        _createElementVNode("main", _hoisted_4, [
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              _createVNode(_Transition, {
                name: "slide-fade",
                mode: "out-in",
                appear: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("footer", null, [
          _createVNode(_component_footer_view)
        ])
      ], 8, _hoisted_3)
    ])
  ], 64))
}